import { render } from "./NovedadesCarousel.vue?vue&type=template&id=5772828a&scoped=true"
import script from "./NovedadesCarousel.vue?vue&type=script&lang=js"
export * from "./NovedadesCarousel.vue?vue&type=script&lang=js"

import "./NovedadesCarousel.vue?vue&type=style&index=0&id=5772828a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5772828a"]])

export default __exports__